import { takeEvery } from 'redux-saga/effects';

import * as phoneActionTypes from 'store/modules/phone/actionTypes';

import { validatePhone } from './utils';

export default function* listenSetPhoneNumber() {
  yield takeEvery(phoneActionTypes.SET_PHONE_NUMBER, validatePhone);
}
